var map = {
	"./logo1.jpg": "EGg+",
	"./logo2.jpg": "UIpq",
	"./logo3.jpg": "gqz6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bmJD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner ^\.\/logo.*\.jpg$
// module id = bmJD
// module chunks = 0